module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "finance"
  }, [_c('banner', {
    attrs: {
      "clazz": "finance-banner",
      "url": "finance",
      "hasDivider": ""
    }
  }, [_c('template', {
    slot: "buttons"
  }, [_c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.goRegister('caiwu-banner-tiyan')
      }
    }
  }, [_vm._v("申请体验")]), _vm._v(" "), _c('el-button', {
    staticClass: "banner-button",
    attrs: {
      "round": ""
    },
    on: {
      "click": this.goConsult
    }
  }, [_vm._v("立即咨询")])], 1)], 2), _vm._v(" "), _c('div', {
    staticClass: "finance-section1"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "section1-content"
  }, [_c('img', {
    staticClass: "section1-img",
    attrs: {
      "src": require("../../assets/img/finance/peitu.png"),
      "alt": "简化财务人员对账"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "section1-misc"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "misc-divider"
  }), _vm._v(" "), _c('p', {
    staticClass: "misc-content"
  }, [_vm._v("\n            财务对账是企业采购工作中一项繁杂、易出错的工作\n            ，企业与供应商之间需要核对对账周期中发生的货物入库、发票、往来货款情况。\n            ERP系统是企业的主要财务管理工具，甄云采购系统中的的财务版块可通过与ERP系统的对接，\n            帮助企业实现对账、发票校验、资金计划、付款申请等过程的管理。\n          ")]), _vm._v(" "), _c('hover-button', {
    attrs: {
      "clazz": "consult-button",
      "text": "立即咨询"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goConsult.apply(null, arguments)
      }
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "finance-section2"
  }, [_c('div', {
    staticClass: "item-list"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "item-tab"
  }, [_c('el-tabs', {
    attrs: {
      "type": "border-card",
      "stretch": ""
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "改善数据准确性"
    }
  }, [_c('div', {
    staticClass: "rel clearfix content"
  }, [_c('div', {
    staticClass: "fl tl left-list"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("改善数据准确性")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  甄云财务对账系统通过与订单协同系统衔接，可入库数据、对账数据、发票数据的关联，关键信息在系统中传递，改善数据准确性。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/finance/peitu1.png"),
      "alt": "改善数据准确性"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg01"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "对账顺序"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl tl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("对账顺序")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  甄云财务对账系统可为企业提供账龄、供应商账/付款条件等数据，帮助企业确定付款顺序。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/finance/peitu2.png"),
      "alt": "对账顺序"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg02"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "支持不同付款对象"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl tl left-list"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("支持不同付款对象")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  企业实际的采购业务中存在两种履约的单据：单笔合同及订单，对应两种不同的付款方式：单笔合同按阶段付款，订单按照入库付款。甄云财务系统支持基于合同付款阶段、已对账的入库数据开具发票、发票校验、及付款申请。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/finance/peitu3.png"),
      "alt": "支持不同付款对象"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg03"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "支持扣款管理"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl tl left-list"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("支持扣款管理")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  对账系统支持对由于质量问题、交期延迟、交货数量不准确产生的对供应商的处罚扣款进行管理，支持供应商在线确认及反馈，帮助企业避免由于扣款过程中的误差及纠纷。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/finance/peitu4.png"),
      "alt": "支持扣款管理"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg04"
  })])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "规范"
    }
  }, [_c('div', {
    staticClass: "clearfix content"
  }, [_c('div', {
    staticClass: "fl tl left-list"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("规范")]), _vm._v(" "), _c('div', {
    staticClass: "border-bottom-tab"
  }), _vm._v(" "), _c('p', {
    staticClass: "left-desc"
  }, [_vm._v("\n                  甄云财务对账系统可帮助企业建立规范的对账请款流程，帮助企业规避过程中的各种问题：对账数据错误、发票丢失、付款不及时等。\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "fr rel right-list"
  }, [_c('div', {
    staticClass: "right-img"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/finance/peitu5.png"),
      "alt": "规范"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "abs right-bg rbg05"
  })])])])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "item-list2"
  })])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "misc-title"
  }, [_c('p', [_vm._v("简化财务人员对账")]), _vm._v(" "), _c('p', [_vm._v("高效，准确，便捷")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tc"
  }, [_c('h1', {
    staticClass: "item-list-title"
  }, [_vm._v("切合财务需求，优化财务办公")]), _vm._v(" "), _c('div', {
    staticClass: "dib tl border-bottom"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0716bab8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/finance.vue
// module id = 530
// module chunks = 12